// import _ from 'lodash';
// window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import {
  AXIOS_NETWORK_ERROR_EVENT,
  buildNetworkErrorNotification,
  isCanceledAxiosError,
  isNetworkAxiosError,
  shouldSuppressAxiosError,
} from "@/Library";
import axios from "axios";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Mark handled axios errors so Bugsnag can ignore them.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      if (isCanceledAxiosError(error)) {
        return Promise.reject(error);
      }

      if (shouldSuppressAxiosError(error)) {
        Object.defineProperty(error, "__suppressBugsnag", {
          value: true,
          enumerable: false,
        });
      }

      if (isNetworkAxiosError(error) && typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent(AXIOS_NETWORK_ERROR_EVENT, {
            detail: buildNetworkErrorNotification(),
          })
        );
      }
    } catch (_) {}

    return Promise.reject(error);
  }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
